
import { isSet, optionsToKeyValuePairs } from "../../../../../../utils/commonUtils";
import { OnTabKeyPress } from "../../../../../../utils/cssUtils";
import { computationRules1 } from "./DrugScreenCollection";

export const VitalSigns = (props)=>{
    // console.log('props.lookupsOptions',props.lookupsOptions);
    const stackedFieldStyle = {
        layout: 'stacked',
        showContainerBorder: false,
        labelWrap: false,
        isLabel: true,
      };
    const charts = [{
        type:'Grid',
        col:'col-md-3',
        className: 'non-dot-exam-scrollable',
        style: {
            position: "sticky",
            top: "0",
            zIndex: "1",
            height: "calc(100vh - 200px)",
            overflowY: "auto",
            overflowX: "hidden"
        },
        data:[{
            type:"PatientDetails",
            employeeDetails:props.employeeDetails,
            visitDetails:props.visitDetails,
            },{
            type:"CompanyDetails",
            companyDetails:props.companyDetails
        },
        {
            type: "ResultSummary",
            results: [
                {
                    normalMsg: '',
                    abnormalMsg: '',
                    data: [
                        { label: 'Pulse', keyVal: 'pulse_rate_result' },
                        { label: 'Blood Pressure', keyVal: 'blood_pressure_result' },
                    ],
                },
            ]
        },
    
    ],
    },{
        type:'Tab',
        col:'col-md-9',
        data:[
            {
                id:'vital_signs',
                label:'Vital Signs',
                data:[
                    {
                        label:'Vitals Signs',
                        labelStyle: 'fw-semibold',
                        fields:[
                        {
                            label:'Blood Pressure Systolic (1st Reading)',
                            isLabel:false,
                            col: 'col-6 border-0 ',
                            type:'NewNumber',
                            placeholder:"Blood pressure",
                            name:'sitting_systolic',
                            id:'sitting_systolic',
                            rangeMax:139,
                            rangeMin:90,
                            onKeyPress:(event)=>OnTabKeyPress(event,"sitting_diastolic",""),
                            Max:3,
                            // required: true,
                        },
                        {
                            label:'Blood Pressure Systolic(2nd Reading)',
                            isLabel:false,
                            col: 'col-6 border-0 ',
                            type:'NewNumber',
                            placeholder:"Blood pressure",
                            name:'second_reading_systolic',
                            id:'second_reading_systolic',
                            rangeMax:139,
                            rangeMin:90,
                            Max:3,
                            // required: (formValues) => {
                            //     const sys = formValues.sitting_systolic;
                            //     if (sys === undefined || sys === null || sys === '') {
                            //         return false;
                            //     }
                            //     const sysNum = Number(sys);
                            //     if (isNaN(sysNum)) {
                            //         return false;
                            //     }
                            //     return sysNum < 90 || sysNum > 139;
                            // },
                        },  
                        {
                            label:'Blood Pressure Diastolic (1st Reading)',
                            isLabel:false,
                            col: 'col-6 border-0 ',
                            type:'NewNumber',
                            placeholder:"Blood pressure",
                            name:'sitting_diastolic',
                            id:'sitting_diastolic',
                            rangeMin:60,
                            rangeMax:89,
                            onKeyPress:(event)=>OnTabKeyPress(event,"pulse_rate"),
                            Max:3,
                            // required: true,
                        },
                        {
                            label:'Blood Pressure Diastolic(2nd Reading)',
                            isLabel:false,
                            col: 'col-6 border-0 ',
                            type:'NewNumber',
                            placeholder:"Blood pressure",
                            name:'second_reading_diastolic',
                            id:'second_reading_diastolic',
                            rangeMin:60,
                            rangeMax:89,
                            // required: (formValues) => {
                            //     const dia = formValues.sitting_diastolic;
                            //     if (dia === undefined || dia === null || dia === '') {
                            //         return false;
                            //     }
                            //     const diaNum = Number(dia);
                            //     if (isNaN(diaNum)) {
                            //         return false;
                            //     }
                            //     return diaNum < 60 || diaNum > 89;
                            // },
                            Max:3,
                        },  
                        {
                            label:'Pulse Rate',
                            isLabel:false,
                            col: 'col-6 border-0 ',
                            type:'NewNumber',
                            placeholder:"Pulse Rate",
                            name:'pulse_rate',
                            rangeMin:60,
                            rangeMax:100,
                            id:'pulse_rate',
                            Max:3,
                            // required: true,
                        },
                        {
                            label:'Pulse Rhythm Regular',
                            ...stackedFieldStyle,
                            type:'RadioGroup',
                            col: 'col-6 border-0 ',
                            name:'pulse_rhythm_regular',
                            id:'pulse_rhythm_regular',
                            options:[{label:'Yes',value:1},{label:'No',value:0}],
                            // required: true,
                        },
                        {
                            label:'Height  (Feet)',
                            placeholder:'Feet',
                            isLabel:false,
                            col: 'col-6 border-0 ',
                            type:'NewNumber',
                            Max:1,
                            name:'height_feet',
                            id:'height_feet',
                            // required: true,
                        },
                        
                        {
                            label:'Inches',
                            isLabel:false,
                            placeholder:'Inches',
                            col: 'col-6 border-0 ',
                            type:'NewNumber',
                            name:'height_inches',
                            id:'height_inches',
                            Max:2,
                            
                        },
                        {
                            label:'Weight (In Pounds)',
                            isLabel:false,
                            placeholder:'Pounds',
                            type:'NewNumber',
                            name:'weight_pounds',
                            id:'weight_pounds',
                            col: 'col-6 border-0 ',
                            Max:3,
                            // required: true,
                        },
                        {
                            label:'Neck Circumference (In)',
                            isLabel:false,
                            placeholder:'Circumference',
                            type:'NewDecimal',
                            name:'neck_circumference',
                            id:'neck_circumference',
                            col: 'col-6 border-0 ',
                        },
                        {
                            label:'Oxygen Saturation (SpO2)',
                            isLabel:false,
                            placeholder:'SpO2',
                            type:'NewNumber',
                            name:'oxygen_saturation',
                            id:'oxygen_saturation',
                            col: 'col-6 border-0 ',
                            Max:3,
                            // required: true,
                        },
                     ]
                },
        
        {
            label: 'Review / Completion',
            labelStyle: 'fw-semibold',
            fields: [
                {
                    type: 'ProviderSignOff',
                    col: 'col-12',
                    fields: [
                        { label: 'Signature PIN',placeholder:'Signature PIN', name: 'provider_pin', col: 'col-12' },
                        { label: 'Signature', type: 'NewSignature', name: 'provider_signature', col: 'col-12' },
                        { label: 'Date', type: 'Date', name: 'signed_date', col: 'col-12' },
                        // { label : "Suggested Result", disabled:true, placeholder:'Not Started',type: "TextInput", name: "suggested_status", col: "col-6"},
                        // Previous options:
                        // { label : "Final Results", type: "SelectList", name: "status", col: "col-12",options:isSet(props.lookupsOptions['chartResult'],[]), statusBasedColor: true },
                        // { label : "Activity Status", type: "SelectList", name: "activity_status", col: "col-12", options: optionsToKeyValuePairs(['Not Started','Ordered','Completed','Cancelled']), statusBasedColor: true },
                        // New standard options:
                        { 
                          label : "Final Results", 
                          type: "SelectList", 
                          name: "status", 
                          col: "col-12",
                          options: optionsToKeyValuePairs(
                            [
                              "Not Started",
                              "Pending",
                              "Normal",
                              "Abnormal",
                              "Negative",
                              "Positive",
                              "Dispensed",
                              "Administered",
                              "Failed",
                              "Passed",
                              "Non-Negative",
                              "Cancelled",
                              "Inconclusive",
                            ],
                            false
                          ),
                          statusBasedColor: true 
                        },
                        { 
                          label : "Activity Status", 
                          type: "SelectList", 
                          name: "activity_status", 
                          col: "col-12", 
                          options: optionsToKeyValuePairs(
                            [
                              "Not Started",
                              "Pending",
                              "Pending Lab Confirmation",
                              "Pending MRO Confirmation",
                              "Ready for Review",
                              "Completed",
                              "Cancelled",
                            ],
                            false
                          ),
                          statusBasedColor: true 
                        },
                    ],
                },
            ],
        }
                ]
            },
            {
                id:'Images',
                label:'Images',
                data:[]
            }
        ]
    }];
    const defaultValue = {
        status:'Not Started',
        suggested_status:'Not Started',
        activity_status:'Not Started',
        pulse_rate_result:'Not Started',
        blood_pressure_result:'Not Started',
        };
    const headers = [];
    return {
        charts,
        defaultValue,
        headers,
        computationFunction: (formData,key) => ({
            ...computationRules(formData,key),
            ...computationRules1(formData,key),
        }),
    };
}


const computationRules = (formData,key)=>{
   const pulse = isSet(formData.pulse_rate,'');
   const systolic = isSet(formData.sitting_systolic,'');
   const systolic2 = isSet(formData.second_reading_systolic,'');
   const diastolic = isSet(formData.sitting_diastolic,'');
   const diastolic2 = isSet(formData.second_reading_diastolic,'');
   let status = evaluateStatus(pulse,systolic,diastolic);
   let pulseRateResult = 'Not Started';
   if(pulse==''){
    pulseRateResult = 'Not Started'
   }else if (pulse >= 60 && pulse <= 100) {
    pulseRateResult =  'Normal';
   }else if(pulse!==''){
    pulseRateResult = 'Abnormal';
   }
   let bloodPressureResult = 'Not Started';
   if(systolic === '' && diastolic === ''){
       bloodPressureResult = 'Not Started'
   }else if (systolic === '' || diastolic === '') {
       bloodPressureResult = 'Pending';
   } else if ((systolic < 0 || systolic > 139) || (diastolic < 0 || diastolic >89)) {
       bloodPressureResult = 'Abnormal';
   } else {
       bloodPressureResult = 'Normal';
   }
   let returnResult = {};
   returnResult = {
    ...returnResult,
    pulse_rate_result:pulseRateResult,
    blood_pressure_result:bloodPressureResult,
   }
   return returnResult;
}


const evaluateStatus = (pulse, systolic, diastolic)=> {
    // Check if any of the parameters are empty
    if (pulse === '' && systolic === '' && diastolic === '') {
        return 'Not Started';
    }
    if (pulse === '' || systolic === '' || diastolic === '') {
       return 'Pending';
    }
    
  
    // Check if pulse is out of range
    if (pulse < 60 || pulse > 100) {
      return 'Failed';
    }
  
    // Check if systolic is out of range
    if (systolic < 0 || systolic > 140) {
      return 'Failed';
    }
  
    // Check if diastolic is out of range
    if (diastolic < 0 || diastolic > 90) {
      return 'Failed';
    }
  
    // If all parameters are within range, return 'passed'
    return 'Passed';
  }
  